var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-pagination',{attrs:{"value":_vm.pagination.page,"records":_vm.pagination.total,"options":_vm.paginationOptions,"per-page":_vm.pagination.perPage},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }